import axios from 'axios';
import { storeAction } from '../storeActions.constant';
import { storeGetters } from '../storeGetters.constant';
import { storeMutation } from '../storeMutations.constant';
import { getBasicHeaders } from '../../common/utils/utils';
import { wrapAction } from '../../common/utils/actionLifecycle';

const toolsState = {
    baseURL: process.env.VUE_APP_BASE_URL,
    newsFeed: null,
};

const newsFeedMutations = {
    [storeMutation.setNewsFeed]: (state, data) => {
        state.newsFeed = data;
    },
    [storeMutation.updateNewsFeed]: (state, data) => {
        data.forEach((news) => {
            if (news.featuredNewsImage && news.featuredNewsImage.url) {
                news.featuredNewsImage = {
                    ...news.featuredNewsImage,
                    url: `${news.featuredNewsImage.url}`,
                };
            }
        });

        state.newsFeed = {
            ...state.newsFeed,
            newsList: [...data],
        };
    },
};

const newsFeedActions = {
    [storeAction.getNewsFeed]: wrapAction(storeAction.getNewsFeed, ({ state, commit }) => {
        return axios({
            //url: '/mocks/homeNews.json',
            url: `${state.baseURL}posts/api/featuredNews/list/home-page`,
            headers: getBasicHeaders(),
            method: 'GET',
        })
            .then((response) => {
                commit(storeMutation.setNewsFeed, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),
    [storeAction.updateNewsFeed]: wrapAction(storeAction.updateNewsFeed, ({ state, commit }, newsData) => {
        return axios({
            url: `${state.baseURL}posts/api/featuredNews/list/home-page`,
            headers: getBasicHeaders(),
            data: newsData,
            method: 'PUT',
        })
            .then((response) => {
                commit(storeMutation.updateNewsFeed, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),
};

const newsFeedGetters = {
    [storeGetters.newsFeed]: state => state.newsFeed,
};

export default {
    namespaced: true,
    state: {
        initialState: toolsState,
        ...toolsState,
    },
    mutations: { ...newsFeedMutations },
    actions: { ...newsFeedActions },
    getters: { ...newsFeedGetters },
};
